/** @format */
import { AxiosResponse, CancelToken } from 'axios';

import { QueryResponse } from '@toucan/common/services/search/types';

import { client } from '@toucan/client/global/axios';

// eslint-disable-next-line @mpb-com/mpb/pure-request-functions -- Legacy code: do not use as an example.
export async function fetchQuoteProductConditions(
    queryParams: string,
    cancelToken: CancelToken | undefined,
    locale: string
) {
    const { data }: AxiosResponse<QueryResponse> = await client.get(
        `/search-service/product/query/?${queryParams}`,
        {
            cancelToken,
            headers: {
                'Content-Language': locale,
            },
        }
    );

    return data;
}

// eslint-disable-next-line @mpb-com/mpb/pure-request-functions -- Legacy code: do not use as an example.
export async function fetchQuoteBuyProducts(
    queryParams: string,
    cancelToken: CancelToken | undefined,
    locale: string
) {
    const { data }: AxiosResponse<QueryResponse> = await client.get(
        `/search-service/product/query/?${queryParams}`,
        {
            cancelToken,
            headers: {
                'Content-Language': locale,
            },
        }
    );

    return data;
}
